<template>
    <div class="position-relative">
        <div class="icon-holder" v-if="loading">
            <Loader/>
        </div>
        <Button
            v-b-tooltip.hover
            title="Clicking this button saves information about your crossprom partner to the Kickstarter update draft. NOTE: with Basic plan you can only use this feature once."
            class="save-to-ks height-auto" 
            type="accept"
            @click.native.stop="saveData">
            Save to Kickstarter
        </Button>
    </div>
</template>

<script>
import Button from '../../Button'
import {useCpInfo, useStore, useRouter} from '../../../../../core/hooks'
import {ref, computed} from '@vue/composition-api'
import {Loader} from '../../../../../components/Icons'

export default {
    name: 'SaveToKickstarter',
    components: {
        Button,
        Loader
    },
    props: {
        data: Object
    },
    setup(props, {root}){
        const {
            cpCampaignsInfo,
            campaignData,
            getPromoInfo,
            saveDraftOnKickstarter,
            formattedDate,
            canPostUpdate
        } = useCpInfo(props.data)

        const {router} = useRouter()
        const {store} = useStore()

        const loading = ref(false)
        const inPremium = computed(() => store.getters.inPremium)

        const sendEvents = () => {
            root.$ga.event('Post Update', 'Save To Kickstarter Clicked', `
                Location: Dashboard Row,
                Campaign: ${props.data.cname},
                UpdateDateId: ${props.data.id},
                UpdateDate: ${formattedDate.value},
                Has Premium: ${inPremium.value}
            `)

            root.$sendMixpanelEvent('Save To Kickstarter Clicked', {
                'Location': 'Dashboard Row',
                'Campaign Name': props.data.cname,
                'Update Date Id': props.data.id,
                'Update Date': formattedDate.value,
                'Has Premium': inPremium.value
            });
        }

        const saveData = async () => {
            
            const canPost = await canPostUpdate()

            if(!canPost && !props.data.kickstarterDraftUrl){
                return router.push({
                    path: '/pricing'
                })
                
            }

            loading.value = true
            await getPromoInfo()
            loading.value = false
            
            saveDraftOnKickstarter()
            sendEvents()
        }

        return {
            saveData,
            loading
        }
    }
}
</script>

<style lang="scss" scoped>
div {
    padding-right: 16px;
}

.save-to-ks {
    width: auto!important;
}

.icon-holder {
    position: fixed;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    z-index: 100000
}
</style>